import * as Timer from './components/Timer.css';
export default {
    Timer
};
